module.exports = __webpack_public_path__ + "a5b4b0d4f61a0ba8fe644a026d674c48.png";